export const AB_VARIANTS_TYPES = {
  DESIGN_ONE: 'DESIGN_ONE',
  DESIGN_ONE_CAPTION: 'DESIGN_ONE_CAPTION',
  DESIGN_TWO_BUTTON_TWO: 'DESIGN_TWO_BUTTON_TWO',
  DESIGN_TWO_BUTTON_THREE: 'DESIGN_TWO_BUTTON_THREE',
  DESIGN_TWO_BUTTON_TWO_CAPTION: 'DESIGN_TWO_BUTTON_TWO_CAPTION',
  DESIGN_TWO_BUTTON_THREE_CAPTION: 'DESIGN_TWO_BUTTON_THREE_CAPTION',
};
